export default {
    tooltip_message: "Selecione produtos, dê um título à lista e compartilhe facilmente nas suas redes sociais",
    navbar: {
        title: 'Compartilhar Produtos'
    }
}